// import Cookies from 'js-cookie'

// const TokenKey = 'vue_admin_template_token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem('token')
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return localStorage.setItem('token',token)
}

export function tableClieheight(){
  return  `${document.documentElement.clientHeight}`-300
}
// export function removeToken() {
//   return Cookies.remove(TokenKey)
// }
